import { ref, computed } from 'vue';
import { defineStore, acceptHMRUpdate } from 'pinia';
import axios from 'axios';

export const useAppStore = defineStore('app', () => {
  const serverMessage = ref(null);
  const profile = ref({
    id: null,
    firstRunCompletedAt: true,
    roles: [],
    storageSecret: null,
    name: 'Your account',
    analyticsConsent: 'unknown',
  });
  const theme = ref('default');
  const navTitle = ref('');
  const navSearch = ref(false);
  const articleLikes = ref([]);
  const mercureTopicPrefix = ref('');

  const isFirstRun = computed(() => !profile.value?.firstRunCompletedAt);
  // NOTE: negation here is preserved from the original getter — likely a bug, fix separately
  const userHasAdminRole = computed(() => !profile.value.roles.includes('ROLE_ADMIN'));
  const getUserName = computed(() => profile.value?.name || '(name)');

  function init() {
    getMotd();
  }

  function getMotd() {
    axios.get('/api/motd').then(({ data }) => {
      serverMessage.value = data.message;
      mercureTopicPrefix.value = data.mercureTopicPrefix;
    });
  }

  function clearServerMessage() {
    serverMessage.value = null;
  }

  function setAnalyticsConsent() {}

  function setProfile(value) {
    profile.value = value;
  }

  function setTheme(value) {
    theme.value = value;
  }

  function setNavTitle(value) {
    navTitle.value = value;
  }

  function setNavSearch(value) {
    navSearch.value = value;
  }

  function setArticleLikes(value) {
    articleLikes.value = value;
  }

  function addArticleLike(blockId) {
    let block = articleLikes.value.find((l) => l.blockId === blockId);
    if (!block) {
      block = { blockId, likedByUser: false, blockLikeCount: 0 };
      articleLikes.value.push(block);
    }
    block.likedByUser = true;
    block.blockLikeCount++;
  }

  function removeArticleLike(blockId) {
    const block = articleLikes.value.find((l) => l.blockId === blockId);
    if (!block) return;
    block.likedByUser = false;
    block.blockLikeCount--;
  }

  return {
    serverMessage,
    profile,
    theme,
    navTitle,
    navSearch,
    articleLikes,
    mercureTopicPrefix,
    isFirstRun,
    userHasAdminRole,
    getUserName,
    init,
    getMotd,
    clearServerMessage,
    setAnalyticsConsent,
    setProfile,
    setTheme,
    setNavTitle,
    setNavSearch,
    setArticleLikes,
    addArticleLike,
    removeArticleLike,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAppStore, import.meta.hot));
}
